// extracted by mini-css-extract-plugin
export default {"wrapper":"styles-module__wrapper--yODMW","img":"styles-module__img--OhyNK","btnContainer":"styles-module__btnContainer--kx5sx","btn":"styles-module__btn--Exh4c"};